import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { useGetModalSizing } from "./useGetModalSizing";
export var useModalStyle = function useModalStyle(hasImage, height, width, contentStyle, noPortal, overlayStyle) {
  var _useViewport = useViewport(),
    isMobile = _useViewport.isMobile;
  return {
    content: _objectSpread(_objectSpread({}, useGetModalSizing(hasImage, isMobile, height, width)), contentStyle !== null && contentStyle !== void 0 ? contentStyle : {}),
    overlay: _objectSpread(_objectSpread({}, noPortal ? {
      position: "fixed",
      width: "100vw",
      height: "100vh",
      top: 0,
      left: 0
    } : {}), overlayStyle !== null && overlayStyle !== void 0 ? overlayStyle : {})
  };
};